/* eslint-disable jira/filename-case */
import { expVal } from '@atlassian/jira-feature-experiments';

/**
 * This helper guards code that is meant to be visible for M0 and onwards.
 */
export const isProjectsInJiraM0Enabled = (): boolean => {
	if (expVal('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 0) {
		return true;
	}
	return false;
};

/**
 * This helper guards code that is meant to be visible for M1 and onwards.
 */
export const isProjectsInJiraM1Enabled = (): boolean => {
	if (expVal('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 1) {
		return true;
	}
	return false;
};

/**
 * This helper guards code that is meant to be visible for M2.
 */
export const isProjectsInJiraM2Enabled = (): boolean => {
	if (expVal('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 2) {
		return true;
	}
	return false;
};
